// columns.tsx
import { GridColDef } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import PublishedCheckbox from "./PublishedCheckbox"; 

export const columns: GridColDef[] = [
  {
    headerName: "Title",
    field: "title",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    headerName: "Description",
    field: "description",
    headerAlign: "left",
    align: "left",
    flex: 1,
    renderCell: (params) => (
      <div>
        {params?.value.replace(/<[^>]+>/g, '').substring(0, 100)}...
      </div>
    ),
  },
  {
    headerName: "Content",
    field: "content",
    headerAlign: "left",
    align: "left",
    flex: 2,
    renderCell: (params) => (
      <div>
        {params?.value.replace(/<[^>]+>/g, '').substring(0, 100)}...
      </div>
    ),
  },
  {
    headerName: "Published",
    field: "is_published",
    headerAlign: "center",
    align: "center",
    flex: 0.8,
    renderCell: (params) => {
      return (
        <div className="flex items-center justify-center">
          <PublishedCheckbox value={params.value} rowId={params.row.id} />
        </div>
      );
    },
  },
  {
    headerName: "Link",
    field: "link",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    headerName: "Image",
    field: "image",
    headerAlign: "center",
    align: "center",
    width: 120,
    renderCell: (params) => {
      const imageUrl = params.value ? process.env.REACT_APP_BACK_HOST + params.value : null;
      return imageUrl ? (
        <img
          src={imageUrl}
          alt="thumbnail"
          className="w-12 h-12 object-cover rounded-md"
        />
      ) : (
        "N/A"
      );
    },
  },
  {
    headerName: "Actions",
    field: "actions",
    headerAlign: "center",
    align: "center",
    flex: 0.6,
    renderCell: (params) => (
      <Link
        to={`/admin/blogs/${params.row.slug}`}
        className="text-blue-500 underline hover:text-blue-700"
      >
        View
      </Link>
    ),
  },
];
